import React from 'react';

export default function AcceptableUse() {
    return (
        <div className="acceptable-use-policy">
            <p className="text-muted mb-4">
                <em>Last Updated: January 2026</em>
            </p>

            <p>
                This Acceptable Use Policy governs your use of Sustainability
                Hub and the Bili AI Assistant. By using our platform, you agree
                to comply with this policy.
            </p>

            <h5 className="mt-4 mb-3 fw-bold">Permitted Use</h5>
            <ul>
                <li>
                    Personal, educational, and research use related to
                    sustainability topics
                </li>
                <li>
                    Reasonable queries to the Bili AI Assistant within daily
                    usage limits
                </li>
                <li>
                    Sharing insights and information learned from the platform
                    with proper attribution
                </li>
            </ul>

            <h5 className="mt-4 mb-3 fw-bold">Prohibited Activities</h5>
            <p>You may NOT:</p>
            <ul>
                <li>
                    Use automated tools, bots, scrapers, or crawlers to access
                    the platform without written permission
                </li>
                <li>
                    Access the Bili AI Assistant programmatically or via API
                    without prior authorization
                </li>
                <li>
                    Circumvent, disable, or interfere with rate limits or usage
                    quotas
                </li>
                <li>
                    Create multiple accounts to evade usage restrictions or bans
                </li>
                <li>Harvest, collect, or store data about other users</li>
                <li>
                    Attempt to extract, reverse-engineer, or replicate the AI
                    assistant or its responses
                </li>
                <li>
                    Use the platform to generate content that is harmful,
                    misleading, or illegal
                </li>
                <li>Impersonate other users or misrepresent your identity</li>
            </ul>

            <h5 className="mt-4 mb-3 fw-bold">Usage Limits</h5>
            <ul>
                <li>
                    Users are subject to daily message limits based on account
                    type
                </li>
                <li>Limits reset at midnight UTC each day</li>
                <li>
                    Exceeding limits may result in temporary access restrictions
                </li>
                <li>
                    Abuse of the platform may result in permanent account
                    suspension
                </li>
            </ul>

            <h5 className="mt-4 mb-3 fw-bold">Enforcement</h5>
            <p>Violations of this policy may result in:</p>
            <ul>
                <li>Temporary or permanent account suspension</li>
                <li>Removal of access to the Bili AI Assistant</li>
                <li>
                    Reporting to appropriate authorities if legally required
                </li>
                <li>Legal action in cases of significant abuse or damages</li>
            </ul>

            <h5 className="mt-4 mb-3 fw-bold">Contact</h5>
            <p>
                Questions about this policy? Contact us at{' '}
                <a href="mailto:support@sustainabilityhub.co">
                    support@sustainabilityhub.co
                </a>
            </p>
        </div>
    );
}
